import { ErrorTypes } from './enum/error.enum'

export class ErrorMessage {
  type: ErrorTypes
  title: string
  url?: string
  message: string
  buttonMessage?: string
}
